<template>
  <section class="ai-test-list">
    <ai-top-menu></ai-top-menu>
    <div class="mb-5">
      <b-container fluid>
        <b-row>
          <b-col sm="11">
            <b-input placeholder="Поиск" class="search-form" size="sm" type="text" v-model="search" v-on:change="updateAIList(1)"></b-input>
            <b-button class="ml-2" size="sm" variant="primary" v-on:click="updateAIList(1)">Ок</b-button>
            <b-button class="ml-2" size="sm" variant="primary" v-on:click="search='', updateAIList(1)">Сброс</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            Total: {{totalData.processed}} / {{totalData.total}}
            <b-button class="ml-2" size="sm" variant="primary" @click="getTotalData">Refresh</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div role="tablist" class="pt-4">
      <Item :item="item" v-for="item in items" :key="item.id"/>
    </div>
    <div class="overflow-auto">
    <b-pagination
      v-model="pagination.currentPage"
      :total-rows="pagination.total"
      :per-page="pagination.limit"
      @change="updateAIList"
    ></b-pagination>
    </div>
  </section>
</template>

<script>
import aiTopMenu from '../components/topMenu';
import Pagination from '@/components/components/pagination';
import {config} from "@/config";
import { createNamespacedHelpers } from 'vuex';
import Item from "@/components/ai/test/Item.vue";
const { mapState } = createNamespacedHelpers('ai')

export default {
  name: "testList",
  components: {
    Item,
    aiTopMenu,
    Pagination
  },
  data() {
    return {
      offset: 1,
      amountPage: 1,
      countRow: 0,
      isImportDelete: {},
      photoFile: null,
      defPhotoURL: null,
      apiDomain: config.apiUrl,
      imgProps: {width: 75, height: 75, class: 'm1'},
      isApplyingImport: false,
      updateFrequency: config.updateFrequency,
      search: '',
    }
  },
  methods: {
    perPage: function (perPage) {
      this.limit = perPage
      this.updateAIList(this.offset)
    },
    updateAIList: function (page) {

      let params  = {
        limit: this.pagination.limit,
        page: page,
        search: this.search
      };
      this.$store.dispatch('ai/GET_LIST', params);

      /*var th = this;
      let funcSuccessResponse = (responseData) => {
        th.list = responseData.data;
        this.pagination.total = responseData.total;
        //th.countRow = 20;//parseInt(responseData.countRow);
      };*/

      /*this.$store.dispatch('SEND_GET', {
        url: '/ai/test?limit=' + this.limit + '&page=' + this.pagination.currentPage + '&search='+ encodeURIComponent(this.search),
        th: th,
        getSuccessResponse: funcSuccessResponse,
        showSuccessMessage: false
      });*/

    },
    formSubmit: function (event) {
      if (event) {
        event.preventDefault()
      }
      return false;
    },
    importKill: function () {
      var th = this;
      this.$store.dispatch('SEND_GET', {
        url: '/goods-import/kill',
        th: th,
        getSuccessResponse: (data) => {
          if (data == undefined) {
            console.log(data);
          }
          th.updateAIList();
        },
        showSuccessMessage: true
      });
    },
    getTotalData() {
      var th = this;
      this.$store.dispatch('ai/GET_TOTAL', {
        th: th,
      });
    }
  },
  computed: {
    currentPage: function () {
      return this.offset;
    },
    ...mapState([
      'totalData',
      'items',
      'pagination'
    ])
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('ai') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
  },
  created() {
    let params  = {
      limit: this.pagination.limit,
      page: this.pagination.currentPage,
      search: this.search
    };
    this.$store.dispatch('ai/GET_LIST', params);
    //this.updateAIList();
    //var th = this;

/*    setInterval(() => {
      if (th.$router.currentRoute.name == 'goodsImportList') {
        th.updateImportList();
      }
    }, th.updateFrequency);*/
  },
}
</script>

<style scoped>
.goods-import-list .card-header .btn-warning.btn-block,
.goods-import-list .card-header .btn-secondary.btn-block,
.goods-import-list .card-header .btn-dark.btn-block,
.goods-import-list .card-header .btn-info.btn-block,
.goods-import-list .card-header .btn-success.btn-block {
  width: 89%;
}

.goods-import-list .card-header .btn-danger.btn-block {
  width: 10%;
  float: right;
}

.toggle .waiting-state {
  display: none;
}

.toggle .process-state {
  display: inline;
}

.process-state {
  display: none;
}

.goods-import-list .btn-block + .btn-block {
  margin-top: 0;
}

.text-align-left {
  text-align: left;
}

.goods-import-list .width-100 {
  width: 100%;
  padding-bottom: 10px;
}

.goods-import-list .btn-load {
  float: left;
  margin-top: 0.5rem;
}

.count-error-box {
  float: left;
  width: 50px;
}
.goods-import-list .search-form {
  display: inline-block;
  width: 90%;
}
</style>